import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=44a402ef&scoped=true&"
import script from "./discover.ts?vue&type=script&lang=ts&"
export * from "./discover.ts?vue&type=script&lang=ts&"
import style0 from "./discover.scss?vue&type=style&index=0&id=44a402ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a402ef",
  null
  
)

export default component.exports